import { defineMessages } from 'react-intl';

export default defineMessages({
    // add string ids and default values for localization here
    plQuoteValidityDays: {
        id: 'quoteandbind.views.ple.quote.Quote Validity Days',
        defaultMessage: 'THIS QUOTE IS VALID FOR ({quoteValidityDays}) DAYS - COVERAGE IS NOT BOUND UNTIL A BINDER IS ISSUED',
    },
    plBrokerageCommission: {
        id: 'quoteandbind.views.ple.quote.Brokerage Commission',
        defaultMessage: 'Brokerage Commission',
    },
    plMimimumRetainedPremium: {
        id: 'quoteandbind.views.ple.quote.Mimimum Retained Premium',
        defaultMessage: 'Mimimum Retained Premium',
    },
    note1: {
        id: 'quoteandbind.views.ple.quote.note1',
        defaultMessage: 'NOTE: The terms we have offered are not necessarily identical to those requested in your application for insurance/ submission form, nor is Premier Canada Assurance obligated to offer such terms.   Please review the terms and conditions of this quote carefully.  Relevant policy forms may be obtained from the undersigned underwriter or refer to our website to locate the applicable forms (please note revision dates for the appropriate form).'
    }, 
    note2: {
        id: 'quoteandbind.views.ple.quote.note2',
        defaultMessage: 'INSURANCE LICENSE NOTICE: Premier Canada Assurance has provided this quotation on the basis that you are duly licensed to sell insurance in the jurisdiction pertaining to this insurance risk.  By virtue of the fact that you have requested this quotation, you are representing to Premier Canada Assurance that you are a duly licensed insurance broker in the relevant jurisdiction.  Premier Canada Assurance may request a copy of such license at any time.'
    } 
});